"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotEmptyIDValue = void 0;
const typing_1 = require("./typing");
const primitives_1 = require("./primitives");
const string_1 = require("./string");
const isNotEmptyIDValue = (fieldValue) => {
    return (0, typing_1.Union)(string_1.isNotEmptyStringValue, primitives_1.isNumberValue)(fieldValue);
};
exports.isNotEmptyIDValue = isNotEmptyIDValue;
